module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABZSURBVHgBpZCBCYAwDAQ/naAjuJlxEh2lm7lCN3gDKpbalpYeJIHnSCBABknlzZrmDn/8M0Muo7D14MeYLNZOyxe0iQ59eDRO78lpnZK0JNX+GK02EQlveAHOBF+/+MidUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-1-1.png
// module id = p8uQ
// module chunks = 1